import { render, staticRenderFns } from "./RequestProjectDialog.vue?vue&type=template&id=995871d6&scoped=true&"
import script from "./RequestProjectDialog.vue?vue&type=script&lang=js&"
export * from "./RequestProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./RequestProjectDialog.vue?vue&type=style&index=0&id=995871d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995871d6",
  null
  
)

export default component.exports